<template>
  <div class="pt-3">
    <div class="back-to-category" @click="goBack">
      <i class="fa fa-angle-left back-icon" aria-hidden="true"></i>
      <a class="back-text">
        {{ item.name }}
      </a>
    </div>
    <div v-for="(item, itemIndex) in getItems" class="nav-item-category" :key="itemIndex">
      <div class="nav-category-divider" v-if="itemIndex === 0"></div>
      <!-- Item with nested sub-items (third level) -->
      <div v-if="item.items && item.items.length > 0">
        <div class="nav-item nav-item-expandable" @click="toggleSubItem(item.id)">
          <div class="nav-item-name">
            {{ item.name }}
            <i class="fa" :class="isExpanded(item.id) ? 'fa-angle-down' : 'fa-angle-right'"
              style="float: right; padding-right: 10px;"></i>
          </div>
        </div>
        <div v-if="isExpanded(item.id)" class="nav-sub-items">
          <div v-for="(subItem, subIndex) in getSubItems(item)" :key="subIndex">
            <b-link :to="{ name: subItem.route }" style="text-decoration: none">
              <div class="nav-item nav-sub-item" :class="{ 'nav-selected': isSelectedRoute(subItem) }">
                <div class="nav-item-name">
                  {{ subItem.name }}
                  <div class="nav-item-arrow" v-if="isSelectedRoute(subItem)" />
                </div>
              </div>
            </b-link>
          </div>
        </div>
      </div>
      <!-- Regular item without sub-items -->
      <b-link v-else :to="{ name: item.route }" style="text-decoration: none">
        <div class="nav-item" :class="{ 'nav-selected': isSelectedRoute(item) }">
          <div class="nav-item-name">
            {{ item.name }}
            <div class="nav-item-arrow" v-if="isSelectedRoute(item)" />
          </div>
        </div>
      </b-link>
      <div class="nav-item-divider"></div>
    </div>
  </div>
</template>

<script>
import auth from '@/api/auth';
import { mapGetters } from 'vuex';

export default {
  name: 'sidebar-level2',
  props: ['item', 'c'],
  data() {
    return {
      expandedItems: [],
    };
  },
  computed: {
    getItems() {
      return this.item && this.item.items
        ? this.item.items.filter(x => this.item.is_user || this.loggedInUserHasReadPermission(x.access))
        : [];
    },
    ...mapGetters(['loggedInUserHasReadPermission']),
  },
  methods: {
    logout() {
      auth.logout();
    },
    goBack() {
      this.$emit('clear');
    },
    isSelectedRoute(item) {
      return item.route === this.$route.name;
    },
    toggleSubItem(itemId) {
      const index = this.expandedItems.indexOf(itemId);
      if (index > -1) {
        this.expandedItems.splice(index, 1);
      } else {
        this.expandedItems.push(itemId);
      }
    },
    isExpanded(itemId) {
      return this.expandedItems.includes(itemId);
    },
    getSubItems(item) {
      return item.items ? item.items.filter(x => this.loggedInUserHasReadPermission(x.access)) : [];
    },
  },
  mounted() {
    // Auto-expand items that have a selected sub-route
    this.getItems.forEach(item => {
      if (item.items && item.items.some(subItem => this.isSelectedRoute(subItem))) {
        this.expandedItems.push(item.id);
      }
    });
  },
};
</script>

<style lang="scss">
.back-to-category {
  height: 39px;
  width: 300px;
  background-color: rgba(0, 0, 0, 0.1);
  padding-top: 5px;

  .back-icon {
    margin-left: 20px;
  }

  .back-text {
    color: #fff;
    height: 18px;
    width: 53px;
    font-size: 12px;
    font-weight: bold;
    line-height: 18px;
    padding-left: 5px;
    cursor: pointer;
    text-transform: uppercase;
  }

  a {
    &:hover {
      text-decoration: none;
    }
  }
}

.nav-item-category {
  text-align: left;
  cursor: pointer;

  .nav-item {
    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }

    width: 300px;
    padding-left: 20px;
    padding-top: 15px; // 18px;
    padding-bottom: 14px; // 17px;

    &.nav-item-expandable {
      cursor: pointer;
    }

    &.nav-sub-item {
      padding-left: 40px;
      font-size: 14px;
    }

    .nav-item-name {
      height: 24px;
      font-size: 16px;
      line-height: 24px;
      display: inline-block;
      padding-left: 10px;
      color: #fff;
      width: 100%;

      a {
        color: #fff;
      }
    }

    &.nav-selected {
      background-color: rgba(0, 0, 0, 0.2);

      .nav-item-arrow {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-right: 6px solid #fff;
        position: absolute;
        right: 0;
        margin-top: -20px;
      }
    }
  }

  .nav-item-divider {
    height: 1px;
    width: 300px;
    opacity: 0.15;
    background-color: #ffffff;
  }
}
</style>
